import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';

const ComingSoon = ({ imageSrc, onClose }) => {
  return (
    <Card
      sx={{
        maxWidth: 400,
        minWidth: 300,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 2,
        textAlign: 'center',
        boxShadow: 'none'
    }}
    >
      <Box sx={{ 
        width: 200, 
        height: 200,
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <img
          src={imageSrc}
          alt="Coming Soon"
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'contain' 
          }}
        />
      </Box>

      <CardContent sx={{ padding: '0 !important' }}>
        <Typography variant="h5" gutterBottom>
          Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We're working hard to bring this feature to you soon!
        </Typography>
      </CardContent>

      <Button 
        variant="contained" 
        sx={{ marginTop: 2 }} 
        onClick={onClose}
      >
        OK
      </Button>
    </Card>
  );
};

export default ComingSoon;